// @flow

export const NEW = 0;
export const COMPLETED = 1;
export const CONFIRMED = 2;
export const CLOSED = 3;

export const stateLabels = {
  [NEW]: 'Väntar på tillval',
  [COMPLETED]: 'Väntar på säljare',
  [CONFIRMED]: 'Väntar på inköp',
  [CLOSED]: 'Avslutad',
};

export const stateClasses = {
  [NEW]: 'new',
  [COMPLETED]: 'completed',
  [CONFIRMED]: 'confirmed',
  [CLOSED]: 'closed',
};

export const states = [{
  id: NEW,
  label: stateLabels[NEW],
}, {
  id: COMPLETED,
  label: stateLabels[COMPLETED],
}, {
  id: CONFIRMED,
  label: stateLabels[CONFIRMED],
}, {
  id: CLOSED,
  label: stateLabels[CLOSED],
}];



// WEBPACK FOOTER //
// ./src/orderStates.js